import { useEffect, useMemo } from 'react';
import { RoutedTabs } from '@mainstage/core-components';
import {
  WbBreadcrumb,
  WbBreadcrumbs,
  WbHeader,
} from '@agilelab/plugin-wb-platform';

import { usePublishEvent } from '@agilelab/plugin-wb-events';
import { extensionManagerNavigatedTopic } from '@agilelab/plugin-wb-events-common';
import { useLocation } from 'react-use';
import { UserPage } from './UserPage';
import { GroupPage } from './GroupPage';
import { ServiceAccountPage } from './ServiceAccount/ServiceAccountPage';
import { WbPage } from '@agilelab/plugin-wb-platform';

export const UserAndGroupsPage = () => {
  const routes = useMemo(() => {
    const enabledRoutes = [];

    enabledRoutes.push({
      path: '/',
      title: 'Users',
      children: <UserPage />,
    });
    enabledRoutes.push({
      path: '/groups',
      title: 'Groups',
      children: <GroupPage />,
    });
    enabledRoutes.push({
      path: '/service-accounts',
      title: 'Service Accounts',
      children: <ServiceAccountPage />,
    });

    return enabledRoutes;
  }, []);

  const { publish } = usePublishEvent({ generatorSystem: 'settings' });
  const location = useLocation();

  useEffect(() => {
    if (location.pathname)
      publish(extensionManagerNavigatedTopic, {
        path: location.pathname,
      });
  }, [location.pathname, publish]);

  return (
    <WbPage themeId="home">
      <WbHeader
        title="Identity and Access Management"
        titleContainerStyle={{ flex: 'none' }}
        breadcrumbs={
          <WbBreadcrumbs>
            <WbBreadcrumb>Administration</WbBreadcrumb>
            <WbBreadcrumb>IAM</WbBreadcrumb>
          </WbBreadcrumbs>
        }
      />
      <RoutedTabs routes={routes} />
    </WbPage>
  );
};
